import { List, Map,Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { FlatRectRecord } from "../../helper/FlatRectRecord";

export const TimelineViewGroupRecord = Record({
  id: null,
  showHeader: true,
  label: null,
  icon: null,
  iconColor: null,
  bounds: FlatRectRecord(),
  headerHeight: null,
  positions: Map(),
  eventIds: List()
});

const data = {
  objects: {
    bounds: "FlatRectRecord",
    eventIds: "List"
  },
  collections: {
    positions: "TimelineViewEventPositionRecord"
  }
};

createFromJS.registerCallback(
  "TimelineViewGroupRecord",
  createFromJS.createNestedCallback(TimelineViewGroupRecord, data)
);
